export const unmaskPhone = (maskedPhone: string): string => {
	if (!maskedPhone) {
		return '';
	}

	return maskedPhone.replace(/[^\d]/g, '');
};
export const formatPhoneNumber = (phoneNumber: string) => {
	if (!phoneNumber) {
		return '';
	}

	phoneNumber = phoneNumber.replace(/\D/g, '');
	const formattedPhoneNumber = phoneNumber.replace(
		/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/,
		'+$1 ($2) $3-$4-$5',
	);
	return formattedPhoneNumber;
};

export const getRandomUUID = () => {
  const answer =  "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
  );

  return answer;
}

export const fromDateToISOStringWithZeroOffset = (date: Date) => {
  const mewDate = new Date(date.getTime());
  const offsetHours = date.getTimezoneOffset() / 60
  mewDate.setHours(offsetHours * -1);

  return mewDate.toISOString();
}

export const pluralize = (number: number, one: string, few: string, many: string) => {
  const n = Math.abs(number);
  const forms = [one, few, many];

  if (n % 10 === 1 && n % 100 !== 11) {
    return forms[0];
  } else if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
    return forms[1];
  } else {
    return forms[2];
  }
}

export const digToTimeString = (dig: number) => {
  const mins = Math.max(0, Math.floor(dig / 60));
  const secs = Math.max(0, Math.floor(dig % 60));
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}